import { Action } from '@ngrx/store';
import { ActionTypes } from '../../core/models/actionTypes';

export const ProfileImageAction = (profileImage: string) => {
  return <Action>{ type: ActionTypes.ProfileImage, payload: profileImage };
};
